import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import {
  selectEmspCdrsListStatus,
  emspCdrsListAsync,
} from "../transactionsSlice";
import { useCallback, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { selectCompany } from "../../homeSlice";
import { SharedInterfaceEmspCdrs } from "./sharedInterface";
import { PublicEmspCdrs } from "../transactionsAPI";
import { EmspSidePanel } from "../sidePanel/emspSidePanel/SidePanel";

export const EmspCdrsTab = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const company = useAppSelector(selectCompany);

  const emspCdrsListStatus = useAppSelector(selectEmspCdrsListStatus);

  useEffect(() => {
    if (company && emspCdrsListStatus === "idle") {
      void dispatch(emspCdrsListAsync({ companyUuid: company.uuid }));
    }
  }, [dispatch, company, emspCdrsListStatus]);

  const sidePanelAction = useCallback(
    (props: Partial<PublicEmspCdrs>) => {
      navigate(`/home/transactions/emspCdrs/${props.uuid}`);
    },
    [navigate],
  );

  if (params.tab !== "emspCdrs") {
    return;
  }

  return (
    <SharedInterfaceEmspCdrs
      sidePanelAction={sidePanelAction}
      sidePanel={<EmspSidePanel />}
    />
  );
};
